import { Link, useLocation, useNavigate } from 'react-router-dom'
import './styles/playersbaja.css'
import { useEffect, useState } from 'react'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Menu from '../components/menu'
import Confirm from '../components/confirm'

//Extras
import { fontType, main, levelColors } from '../assets/extras'
import { db } from '../assets/connections'
import { collection, deleteDoc, doc, getDocs, query, setDoc } from 'firebase/firestore'
import { getAge, getCurrentDate, validateEmail } from '../assets/validator'
import * as XLSX from "xlsx"

const PlayersBaja = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        players: [],
        player: ""
    })

    //Variable para el selector de informacion
    const [ infoSelect, setInfoSelect ] = useState("Categoria")

    //Variables para el control de modificaciones por conjunto
    const [ selectedPlayers, setSelectedPlayers ] = useState([])

    //Variables para el control de filtro de meses
    const [ selectedMes, setSelectedMes ] = useState(-1)

    const [ confirmDeletePlayers, setConfirmDeletePlayers ] = useState({
        show: false,
        title: "",
        text: ""
    })
    const [ confirmAltaPlayers, setConfirmAltaPlayers ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que crea un XLSX
    const hanldeCreateXLSX = () => {
        var data = []
        variables.players.map(v => {
            data.push({
                Correo: v.id,
                Nombre: v.nombre_jugador,
                Telefono: v.telefono_jugador,
                FechaNacimiento: v.edad_jugador,
                BajaJugador: v.fecha_baja,
                Rama: v.rama_jugador,
                Nivel: v.nivel_jugador != "" ? v.nivel_jugador : "Sin nivel",
                Categoria: v.categoria_jugador != "" ? v.categoria_jugador : "Sin categoria",
                Ranking: v.ranking_jugador
            })
        })

        // Crear la hoja de cálculo
        const worksheet = XLSX.utils.json_to_sheet(data)

        // Crear el libro de trabajo
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, "Datos")

        // Generar archivo Excel
        XLSX.writeFile(workbook, "JugadoresBaja.xlsx")

        showMessage("XLSX generado correctamente", "success")
    }

    //Funcion que da de baja a todos los jugadores de la lista
    const onHandleAltaPlayers = async () => {
        setConfirmAltaPlayers(prev => ({
            ...prev,
            show: false
        }))
        
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        var cont = 0
        for(let i = 0; i < selectedPlayers.length; i++){
            var jugador = variables.players.filter(d => d.id === selectedPlayers[i])[0]
            await altaJugador(jugador).then(r => {
                cont ++
            })
        }

        if(cont === selectedPlayers.length){
            setSelectedPlayers([])
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugadores dados de alta exitosamente", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1500)
            }, 50)
        } else if(cont < selectedPlayers) {
            setSelectedPlayers([])
            setVariables(prev => ({
                ...prev,
                loading: false
            }))

            setTimeout(() => {
                showMessage("No todos los jugadores se dieron de alta correctamente", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1500)
            }, 50)
        }

    }
    const altaJugador = async (data) => {
        var datos = {
            ...data,
            clases_jugador: [],
            asistencias_jugador: 0,
            ranking_jugador: 0,
            ultima_asistencia: "----/--/--",
            fecha_alta: getCurrentDate()
        }
        delete datos.id

        await setDoc(doc(doc(db, ref), "Jugador", datos.correo_jugador), datos).then(r => {
            deletingPlayer(datos.correo_jugador)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al eliminar jugador antiguo", "error")
            }, 100)
        })
    }

    //Funcion que elimina a todos los jugadores de la lista
    const onHandleDeletePlayers = async () => {
        setConfirmDeletePlayers(prev => ({
            ...prev,
            show: false
        }))
        
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        var cont = 0
        for(let i = 0; i < selectedPlayers.length; i++){
            var jugador = variables.players.filter(d => d.id === selectedPlayers[i])[0]
            await deletingPlayer(jugador.id).then(r => {
                cont ++
            })
        }

        if(cont === selectedPlayers.length){
            setSelectedPlayers([])
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugadores eliminados exitosamente", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1500)
            }, 50)
        } else if(cont < selectedPlayers) {
            setSelectedPlayers([])
            setVariables(prev => ({
                ...prev,
                loading: false
            }))

            setTimeout(() => {
                showMessage("No todos los jugadores se eliminaron correctamente", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1500)
            }, 50)
        }
    }
    const deletingPlayer = async (correo) => {
        await deleteDoc(doc(doc(db, ref), "JugadorBaja", correo)).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al eliminar jugador", "error")
            }, 100)
        })
    }

    //Funcion que obtiene todos los jugadores dados de baja
    const getPlayers = async () => {
        await getDocs(query(collection(doc(db, ref), "JugadorBaja"))).then(r => {
            var aux = []
            r.docs.map(v => {
                var d = v.data()
                var newObject = {
                    id: v.id,
                    ...d
                }
                aux.push(newObject)
            })

            aux.sort((a, b) =>
                a.nombre_jugador.localeCompare(b.nombre_jugador, "es", { sensitivity: "base" })
            )

            setVariables(prev => ({
                ...prev,
                loading: false,
                players: aux
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))

            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getPlayers()
        }
    }, [])


    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div className='mainPlayersBaja'>

                <Confirm
                    setConfirm={setConfirmDeletePlayers}
                    confirm={confirmDeletePlayers}
                    onHandle={onHandleDeletePlayers}
                />

                <Confirm
                    setConfirm={setConfirmAltaPlayers}
                    confirm={confirmAltaPlayers}
                    onHandle={onHandleAltaPlayers}
                />

                <Snack />

                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.title,
                    paddingBottom: 0
                }}>JUGADORES BAJA</h2>
                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.text,
                    marginTop: -50,
                    marginBottom: 40,
                    fontSize: 18,
                    padding: 10,
                    paddingBottom: 20,
                    paddingTop: 0
                }}>{
                    localStorage.getItem("authToken") ? 
                        JSON.parse(localStorage.getItem("authToken")).nombre_academia
                    : ""
                }</h2>

                <Menu
                    academia={academia}
                    reference={ref}
                />

                <div className='mainPlayersBajaCont' style={{
                    fontFamily: fontType.text
                }}>
                    <div className='players'>
                        <table className='table'>
                            <tr>
                                <th></th>
                                <th>Nombre</th>
                                <th>
                                    <div className='custom-select'>
                                        <select value={infoSelect} onChange={e => {
                                            setInfoSelect(prev => e.target.value)
                                        }}>
                                            <option value="Categoria">Categoria</option>
                                            <option value="Correo">Correo</option>
                                            <option value="Telefono">Telefono</option>
                                            <option value="Edad">Edad</option>
                                            <option value="FechaBaja">Fecha de baja</option>
                                            <option value="Rama">Rama</option>
                                            <option value="Ranking">Ranking</option>
                                        </select>
                                    </div>
                                </th>
                            </tr>
                            {
                                variables.players.length > 0 ?
                                    selectedMes == -1 ?
                                        !variables.player ?
                                            variables.players.map((v, i) => {
                                                return (
                                                    <Player v={v} reference={ref} academia={academia} infoSelect={infoSelect} selectedPlayers={selectedPlayers} setSelectedPlayers={setSelectedPlayers} navigation={navigate} />
                                                )
                                            })
                                        :
                                        variables.players.filter((v) => v.nombre_jugador.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize().match(variables.player.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize())).map(v => {
                                            return (
                                                <Player v={v} reference={ref} academia={academia} infoSelect={infoSelect} selectedPlayers={selectedPlayers} setSelectedPlayers={setSelectedPlayers} navigation={navigate} />
                                            )
                                        })
                                    : selectedMes == 0 ?
                                        !variables.player ?
                                            variables.players.filter(v => v.fecha_baja == "" || v.fecha_baja == "----/--/--" || v.fecha_baja == undefined).map((v, i) => {
                                                return (
                                                    <Player v={v} reference={ref} academia={academia} infoSelect={infoSelect} selectedPlayers={selectedPlayers} setSelectedPlayers={setSelectedPlayers} navigation={navigate} />
                                                )
                                            })
                                        :
                                        variables.players.filter((v) => v.nombre_jugador.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize().match(variables.player.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize()) && 
                                            (v => v.fecha_baja == "" || v.fecha_baja == "----/--/--" || v.fecha_baja == undefined)).map(v => {
                                            return (
                                                <Player v={v} reference={ref} academia={academia} infoSelect={infoSelect} selectedPlayers={selectedPlayers} setSelectedPlayers={setSelectedPlayers} navigation={navigate} />
                                            )
                                        })
                                    : selectedMes > 0 ?
                                        !variables.player ?
                                            variables.players.filter(v => (v.fecha_baja != "" && v.fecha_baja != undefined) && (parseInt(v.fecha_baja.split("-")[1]) == selectedMes)).map((v, i) => {
                                                return (
                                                    <Player v={v} reference={ref} academia={academia} infoSelect={infoSelect} selectedPlayers={selectedPlayers} setSelectedPlayers={setSelectedPlayers} navigation={navigate} />
                                                )
                                            })
                                        :
                                        variables.players.filter((v) => v.nombre_jugador.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize().match(variables.player.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize()) && 
                                        (v.fecha_baja != "" && v.fecha_baja != undefined) && (parseInt(v.fecha_baja.split("-")[1]) == selectedMes)).map(v => {
                                            return (
                                                <Player v={v} reference={ref} academia={academia} infoSelect={infoSelect} selectedPlayers={selectedPlayers} setSelectedPlayers={setSelectedPlayers} navigation={navigate} />
                                            )
                                        })
                                    : []
                                : []
                            }
                        </table>
                    </div>
                    <div className='menu'>
                        <p style={{
                            marginBottom: 10
                        }}><span style={{fontWeight: "bold"}}>Total:</span> {variables.players.length} jugadores</p>
                        <input placeholder='Buscar jugador'
                            value={variables.player}
                            onChange={e => {
                                const t = e.target.value
                                setVariables(prev => ({
                                    ...prev,
                                    player: t
                                }))
                            }}
                        />

                            <div className='custom-select' style={{
                                marginTop: 5
                            }}>
                                <select id="Mes" name="Mes" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={selectedMes}
                                    onChange={e => {
                                        setSelectedMes(prev => (e.target.value))
                                    }}
                                >
                                    <option value={-1}>Todos los meses</option>
                                    <option value={0}>Sin fecha de baja</option>
                                    <option value={1}>Enero</option>
                                    <option value={2}>Febrero</option>
                                    <option value={3}>Marzo</option>
                                    <option value={4}>Abril</option>
                                    <option value={5}>Mayo</option>
                                    <option value={6}>Junio</option>
                                    <option value={7}>Julio</option>
                                    <option value={8}>Agosto</option>
                                    <option value={9}>Septiembre</option>
                                    <option value={10}>Octubre</option>
                                    <option value={11}>Noviembre</option>
                                    <option value={12}>Diciembre</option>
                                </select>
                            </div>

                        <button style={{
                            backgroundColor: "white",
                            color: "black",
                            fontFamily: fontType.subTitle,
                            width: "100%"
                        }} className='button-option' onClick={hanldeCreateXLSX}>
                            CREAR XLSX
                        </button>

                        {
                            selectedPlayers.length > 0 ?
                                <div className='button-option' style={{
                                    backgroundColor: main
                                }}
                                onClick={() => {
                                    setConfirmAltaPlayers(prev => ({
                                        ...prev,
                                        title: "DAR DE ALTA JUGADORES",
                                        text: "¿Estas seguro de dar de alta " + selectedPlayers.length + " jugador(es)?",
                                        show: true
                                    }))
                                }}
                                >
                                    <p style={{
                                        fontFamily: fontType.subTitle
                                    }}>
                                        DAR DE ALTA ({selectedPlayers.length}) JUGADORES
                                    </p>
                                </div>
                            : null
                        }
                        
                        {
                            selectedPlayers.length > 0 ?
                                <div className='button-option' style={{
                                    backgroundColor: "#770000"
                                }}
                                onClick={() => {
                                    setConfirmDeletePlayers(prev => ({
                                        ...prev,
                                        title: "ELIMINAR JUGADORES",
                                        text: "¿Estas seguro de eliminar permanentemente " + selectedPlayers.length + " jugador(es)?",
                                        show: true
                                    }))
                                }}
                                >
                                    <p style={{
                                        fontFamily: fontType.subTitle
                                    }}>
                                        ELIMINAR ({selectedPlayers.length}) JUGADORES
                                    </p>
                                </div>
                            : null
                        }

                    </div>
                </div>

            </div>
        )
}

const Player = ({ v, reference, academia, infoSelect, selectedPlayers, setSelectedPlayers, navigation }) => {

    const color = v.nivel_jugador === "Etapa roja" ? levelColors.Etapa_roja :
                v.nivel_jugador === "Etapa naranja" ? levelColors.Etapa_naranja :
                v.nivel_jugador === "Etapa verde" ? levelColors.Etapa_verde :
                v.nivel_jugador === "Clase D" ? levelColors.Clase_D :
                v.nivel_jugador === "Clase C" ? levelColors.Clase_C :
                v.nivel_jugador === "Clase B" ? levelColors.Clase_B :
                v.nivel_jugador === "Clase A" ? levelColors.Clase_A :
                v.nivel_jugador === "Profesional" ? levelColors.Profesional : "rgba(0, 0, 0, 0)"

    return (
        <tr className='fila'>
            <td style={{
                width: "50px"
            }}>
                <input
                    style={{
                        backgroundColor: "red"
                    }}
                    type="checkbox"
                    id="selectPlayer"
                    name="selectPlayer"
                    onChange={e => {
                        //Validamos si el jugador no esta en la lista
                        if(!selectedPlayers.includes(v.id)){
                            selectedPlayers.push(v.id)
                            setSelectedPlayers(prev => [
                                ...prev
                            ])
                        } else {
                            setSelectedPlayers(prev => [
                                ...selectedPlayers.filter(id => id !== v.id)
                            ])
                        }
                    }}
                    checked={selectedPlayers.includes(v.id)}
                />
            </td>
            <td className='nombre' onClick={() => {
                navigation("/players/baja/player", {
                    state: {
                        ref: reference,
                        id: v.id,
                        academia: academia
                    }
                })
            }} style={{
                borderColor: color
            }}>{v.nombre_jugador}</td>
            <td className='extraInfo' style={{
                borderColor: color
            }}>
                <p>
                    {
                        infoSelect === "Categoria" ?
                            (v.categoria_jugador ? v.categoria_jugador : "No tiene categoria")
                        : infoSelect === "Correo" ?
                            validateEmail(v.id) ? v.id : "No hay un correo asignado"
                        : infoSelect === "Telefono" ?
                            v.telefono_jugador
                        : infoSelect === "Edad" ?
                            v.edad_jugador ? getAge(v.edad_jugador) : "El jugador no tiene una edad registrada"
                        : infoSelect === "FechaAlta" ?
                            v.fecha_alta ?
                                v.fecha_alta
                            : "No hay una fecha de alta"
                        : infoSelect === "FechaBaja" ?
                            v.fecha_baja ?
                                v.fecha_baja === "----/--/--" ?
                                    "No hay una fecha de baja"
                                : v.fecha_baja
                            : "No hay una fecha de baja"
                        : infoSelect === "Rama" ?
                            v.rama_jugador
                        : infoSelect === "Ranking" ?
                            v.ranking_jugador
                        : "No se ha seleccionado una opcion"
                    }
                </p>
            </td>
        </tr>
    )
}

export default PlayersBaja